module.exports = "<svg viewBox=\"0 0 17.4 17.4\" fill=\"#fff\" height=\"24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M15.4,0L8.7,6.7L2,0L0,2l6.7,6.7L0,15.4l2,2l6.7-6.7l6.7,6.7l2-2l-6.7-6.7L17.4,2L15.4,0z M8.7,7.4L2,0.7L0.7,2l6.7,6.7\nl-6.7,6.7L2,16.7L8.7,10l6.7,6.7l1.3-1.3L10,8.7L16.7,2l-1.3-1.3L8.7,7.4z\"/>\n</svg>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/web-interactive/web-interactive/lib/images/icons/x.svg
// module id = 819
// module chunks = 1